import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectCreateMultipleDocumentFilters = createSelector(
  [(store: RootState) => store.massiveDocumentCreate.createFilters],
  (data) => data
);
